
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/category/[categorySlug]",
      function () {
        return require("private-next-pages/news/category/[categorySlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/category/[categorySlug]"])
      });
    }
  